import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M15.62 17.625c-.074 1.852-1.618 3.424-3.685 3.374-.481-.012-1.076-.18-2.265-.515-2.861-.807-5.345-2.164-5.941-5.202-.11-.559-.11-1.188-.11-2.445v-1.674c0-1.257 0-1.886.11-2.445.596-3.038 3.08-4.395 5.941-5.202 1.19-.335 1.784-.503 2.265-.515 2.067-.05 3.61 1.522 3.684 3.374"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M10.62 12h11m-11 0c0-.7 1.993-2.008 2.5-2.5m-2.5 2.5c0 .7 1.993 2.008 2.5 2.5"
    }, null, -1)
  ])))
}
export default { render: render }